var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendingUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4833 17.6725C32.4833 16.706 33.2668 15.9225 34.2333 15.9225H48.2332C49.1997 15.9225 49.9832 16.706 49.9832 17.6725V31.6725C49.9832 32.639 49.1997 33.4225 48.2332 33.4225C47.2667 33.4225 46.4832 32.639 46.4832 31.6725V19.4225H34.2333C33.2668 19.4225 32.4833 18.639 32.4833 17.6725Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4425 16.4068C50.1411 17.0746 50.1662 18.1824 49.4983 18.8811L32.2137 36.9644C31.6455 37.5588 30.7402 37.6775 30.038 37.2496L19.8445 31.0379L8.74848 44.4539C8.13249 45.1987 7.02938 45.303 6.28461 44.6871C5.53984 44.0711 5.43544 42.968 6.05142 42.2232L18.113 27.6399C18.6673 26.9697 19.6295 26.8083 20.3722 27.2608L30.6567 33.528L46.9682 16.4627C47.636 15.764 48.7438 15.739 49.4425 16.4068Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending-up.846dc572.svg";
export { ForwardRef as ReactComponent };